import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpResource } from './resource/http-resource';

@Injectable({
  providedIn: 'root'
})
export class BookHttpService {
  constructor(private http: HttpResource) {}

  generateFlipbook(studentId: string): Observable<string> {
    return this.http.post<string>(`/Heyzine/virtualBook/${studentId}`, {});
  }
}
